import pages from './pages'
import errors from './errors'
import fields from './fields'
import confirm from './confirm'
import tour from './tour'
import login from './feat/login'
import signUp from './feat/sign-up'
import booking from './feat/booking'
import kintellCard from './feat/kintell-card'
import myKintell from './feat/my-kintell'
import uploadImage from './feat/upload-image'
import notInterested from './feat/not-interested'
import modal from './feat/modal'
import codeOfConduct from './feat/code-of-conduct'
import faq from './feat/faq'
import giftCards from './feat/gift-cards'
import becomeAnAdvisor from './feat/become-an-advisor'
import roundup from './feat/roundup'

export default {
  pages,
  errors,
  fields,
  confirm,
  tour,
  login,
  signUp,
  booking,
  kintellCard,
  myKintell,
  uploadImage,
  notInterested,
  modal,
  codeOfConduct,
  faq,
  becomeAnAdvisor,
  roundup,
  giftCards,
}

export {
  pages,
  errors,
  fields,
  confirm,
  tour,
  login,
  signUp,
  booking,
  kintellCard,
  myKintell,
  uploadImage,
  notInterested,
  modal,
  codeOfConduct,
  faq,
  becomeAnAdvisor,
  roundup,
  giftCards,
}
